import { DirectionalHint, FontIcon, TooltipHost } from '@fluentui/react';
import { FC } from 'react';
import LayeredIcons, { IconProps } from './LayeredIcons';
import { IconContainer } from './StyledComponents';

const defaultButton: IconProps[] = [
    { iconName: 'CircleRing' },
    { iconName: 'RadioBullet', size: 0.35, positionX: 0.275, positionY: 0.5 },
    { iconName: 'RadioBullet', size: 0.35, positionX: 0.5, positionY: 0.5 },
    { iconName: 'RadioBullet', size: 0.35, positionX: 0.725, positionY: 0.5 },
];

interface IProps {
    onClick(): void;
    icon?: string | IconProps[];
    tooltip?: string;
}

export const ExtrasButton: FC<IProps> = ({ onClick, icon = defaultButton, tooltip }) => {
    const button = (
        <IconContainer onClick={onClick} className="extras-button">
            {
                typeof icon === 'string'
                    ? <FontIcon iconName={icon} />
                    : <LayeredIcons icons={icon} />
            }
        </IconContainer>
    );

    return tooltip
        ? <TooltipHost content={tooltip} directionalHint={DirectionalHint.topRightEdge}>{button}</TooltipHost>
        : button;
};